import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// import Icon from '../../elements/icon'
import CloseButton from '../../elements/closeButton'
// import Null from '../../elements/null'
// import { Icons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'
import { setPageTitle, setPageTitleExtra } from '../../../actions/common'

// import styles
import './header.scss'

class Header extends Component {
  componentDidMount () {
    if (this.props.router === undefined) return
    let pathname = this.props.router.location.pathname
    if (pathname.indexOf('/orders/') > -1 || pathname.indexOf('/pricecalculation/') > -1) {
      window.onresize = this.checkForOverlaps
    }
  }

  componentDidUpdate () {
    if (this.props.router === undefined) return
    let pageTitleExtra = this.props.pageTitleExtra
    if (pageTitleExtra !== undefined && pageTitleExtra !== null && this.props.pageTitle.extra !== pageTitleExtra) {
      this.props.setPageTitleExtra(pageTitleExtra)
    }
    let pathname = this.props.router.location.pathname
    if (pathname.indexOf('/orders/') > -1 || pathname.indexOf('/pricecalculation/') > -1) {
      this.checkForOverlaps()
    }
  }

  checkForOverlaps () {
    let item = document.getElementsByClassName('header')[0]
    if (item === undefined) return

    let text = item.getElementsByClassName('orderIdentification')[0]
    if (text === undefined) return
    text = text.childNodes[1].childNodes
    if (text.length === 1) return
    text = text[1]

    let navigation = item.lastChild.lastChild.childNodes[1]

    if (text !== undefined && navigation !== undefined && text.getBoundingClientRect !== undefined && navigation.getBoundingClientRect !== undefined) {
      let boundingText = text.getBoundingClientRect()
      let boundingNavigation = navigation.getBoundingClientRect()

      if (boundingText.right > boundingNavigation.left) {
        text.style.display = 'none'
      } else {
        text.style.display = ''
      }
    }
  }

  render () {
    // Extra class
    let extraClass = ''
    if (this.props.lightBlue) {
      extraClass = 'lightBlue'
    }
    // Icon
    let icon = ''
    if (typeof this.props.icon !== 'undefined') {
      icon = <img src={'/images/icons/' + this.props.icon} className='header__icon' />
    } else if (typeof this.props.svg !== 'undefined') {
      icon = <img src={this.props.svg} className='header__icon' />
    }

    const hasTitle = icon || this.props.title
    return (
      <div className={'header ' + extraClass}>
        {this.props.renderLeftBefore !== null && <span>{this.props.renderLeftBefore()}</span>}
        {hasTitle && <span>{icon}{this.props.title}&nbsp;</span>}
        {this.props.renderLeft !== null && <span>{this.props.renderLeft()}</span>}
        <span className='content'>{this.props.children}</span>
        <span className='filler' />
        <span className='buttons'>
          {this.props.renderRight !== null && this.props.renderRight()}
          {this.props.renderButtons !== null && [<span className='spacing' key='spacer_1' />, this.props.renderButtons()]}

          {this.props.showBack && <span className='spacing' key='spacer_2' />}
          {this.props.showBack && this.props.headerButtonsGoBack(this.props.router, translation)}

        </span>
      </div>
    )
  }
}

Header.propTypes = {
  renderRight: PropTypes.func
}

Header.defaultProps = {
  renderRight: null,
  renderLeft: null,
  renderLeftBefore: null,
  renderButtons: null,
  headerButtonsGoBack: (router, t) => {
    const goBack = () => {
      let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders'])
      if (routeItem !== null) {
        if (routeItem.pathname === '/orders') {
          router.replace(routeItem.pathname + '?orderid=' + router.params.orderID)
        } else {
          router.replace(routeItem.pathname)
        }
      } else {
        router.goBack()
      }
    }
    return <CloseButton key='close' onClick={goBack} ariaText={t('2060')} />
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    pageTitle: state.common.pageTitle
  }
}

export default connect(mapStateToProps, {
  setPageTitle,
  setPageTitleExtra
})(Header)



// WEBPACK FOOTER //
// ./src/app/shared/components/Header/index.js